module.exports['sprintf'] = require('./sprintf')
